import axiosClient from "./axiosClient.js";
import ROUTES from "../constants/routes.js";

const VehicleInspections = {
  getAll() {
    return axiosClient.get(ROUTES.VEHICLE_INSPECTIONS);
  },

  create(data) {
    return axiosClient.post(ROUTES.CREATE_INSPECTION, data);
  },

  getById(id) {
    return axiosClient.get(`${ROUTES.VEHICLE_INSPECTIONS}/${id}`);
  }
};

export default VehicleInspections;
